import { apiRequest } from "../util/apiUtils";

export const collectionTemplateList = async (params) => {
  try {
    const res = await apiRequest("get", `/collection-template/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const collectionTemplateAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `collection-template/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const collectionTemplateDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `collection-template/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const collectionTemplateStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `collection-template/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const collectionTemplateOrdering = async (payload) => {
  try {
    const res = await apiRequest("patch", `/collection-template/ordering`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
